import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid";
import { Input } from "@material-tailwind/react";
import React, { useState } from "react";

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: boolean;
}
const InputPassword = ({
  value,
  onChange = () => {},
  disabled = false,
  error = false,
}: Props) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative flex w-full max-w-[24rem]">
      <Input
        size="lg"
        label="กรอกข้อมูล"
        type={visible ? "text" : "password"}
        required
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        error={error}
        autoComplete="off"
        minLength={8}
        maxLength={16}
      />
      {visible ? (
        <EyeIcon
          color="gray"
          className="cursor-pointer w-6 h-6 mt-1.5 mr-2 !absolute right-1 top-1 rounded"
          onClick={() => setVisible((prev) => !prev)}
        />
      ) : (
        <EyeSlashIcon
          color="gray"
          className="cursor-pointer w-6 h-6 mt-1.5 mr-2 !absolute right-1 top-1 rounded"
          onClick={() => setVisible((prev) => !prev)}
        />
      )}
    </div>
  );
};

export default InputPassword;
